export default {
  Oops: '/images/oops.webp',
  LandingBG: '/images/landing_bg.webp',
  Logo: '/images/logo.webp',
  WebPoster: '/images/web_poster.webp',
  CricketBackground: '/images/cricket_background_.webp',
  KabaddiBackground: '/images/kabaddi_background.webp',
  FantasyCricket: '/images/fantasy_cricket_.webp',
  FantasyKabaddi: '/images/fantasy_kabaddi_.webp',
  FantasySubstitute: '/images/fantasy_substitute_.webp',
  FantasyFootball: '/images/fantasy_football.webp',
  FootballBackground: '/images/football_background_.webp',
  Poker: '/images/poker_.webp',
  YesNo: '/images/yes_no_tiles_.webp',
  DefaultCategoryIcon: '/images/default_category_icon.webp',
  DefaultPlayerImage: '/images/default_player_image.webp',
  DefaultPlayerImageMobile: '/images/default_player_image_mobile.webp',
  DefaultMatchLogo: '/images/default_match_logo.webp',
  IPhone: '/images/iphone.webp',
  Ball: '/images/ball.webp',
  QuestionPlayerBG: '/images/question_player_bg.webp',
  QuestionBG: '/images/question_bg.webp',
  QuestionTitleBG: '/images/question_title_bg.webp',
  GL: '/images/GL.webp',
  SL: '/images/SL.webp',
  WL: '/images/WL.webp',
  WeeklyL: '/images/WeeklyL.webp',
  OnePlus10: '/images/one_plus_10.webp',
  R15: '/images/r15.webp',
  IPhone13Pro: '/images/iphone_13_pro.webp',
  Gold10GM: '/images/gold10gm.webp',
  Gold20GM: '/images/gold20gm.webp',
  Wallet: '/images/Wallet.webp',
  Versus: '/images/versus.webp',
  chestLeftArrow: '/images/Left_arrow.webp',
  chestRightArrow: '/images/Right_arrow.webp',
  chestLeftArrowDark: '/images/left_arrow_dark.webp',
  chestRightArrowDark: '/images/right_arrow_dark.webp',
  couponsListBg: '/images/Offer_wall_coupon_default.webp',
  multiple: '/images/multiple.webp',
  shareContestIcon: '/images/share_contest_icon.webp',
  exit: '/images/exit.webp',
  gameInfoBannerBg: '/images/gameinfo_banner_bg.webp',
  pokerImg: '/images/poker-fg.webp',
  fantasyCricketImg: '/images/fantasy_cricket_fg.webp',
  smashTheRockImg: '/images/smash-the-rock.webp',
  fantasyFootballPoster: '/images/football_poster.webp',
  cricketTeamPreviewBg: '/images/cricket_team_preview_bg.webp',
  footballTeamPreviewBg: '/images/football_team_preview_bg.webp',
  yellowRightArrow: '/images/yellow_right_arrow.webp',
  yellowLeftArrow: '/images/yellow_left_arrow.webp',
  bannerImageHome: '/images/Banners-1.webp',
  fantasyCricketPosterBg: '/images/game_posters/fantasy_cricket_bg.webp',
  fantasyCricketPosterTitle: '/images/game_posters/fantasy_cricket_title.webp',
  fantasyCricketPosterGameImg: '/images/game_posters/fantasy_cricket_img.webp',
  fantasyFootballPosterBg: '/images/game_posters/fantasy_football_bg.webp',
  fantasyFootballPosterTitle: '/images/game_posters/fantasy_football_title.webp',
  fantasyFootballPosterGameImg: '/images/game_posters/fantasy_football_img.webp',
  pokerPosterBg: '/images/game_posters/poker_bg.webp',
  pokerPosterTitle: '/images/game_posters/poker_title.webp',
  pokerPosterGameImg: '/images/game_posters/poker_img.webp',
  numberSnakePosterBg: '/images/game_posters/number_snake_bg.webp',
  numberSnakePosterTitle: '/images/game_posters/number_snake_title.webp',
  numberSnakePosterGameImg: '/images/game_posters/number_snake_img.webp',
  quickMathsPosterBg: '/images/game_posters/quick_maths_bg.webp',
  quickMathsPosterTitle: '/images/game_posters/quick_maths_title.webp',
  quickMathsPosterGameImg: '/images/game_posters/quick_maths_img.webp',
  cricketBatterPosterBg: '/images/game_posters/cricket_batter_challenge_bg.webp',
  cricketBatterPosterTitle: '/images/game_posters/cricket_batter_challenge_title.webp',
  cricketBatterPosterGameImg: '/images/game_posters/cricket_batter_challenge_img.webp',
  lastWicketPosterBg: '/images/game_posters/last_wicket_bg.webp',
  lastWicketPosterTitle: '/images/game_posters/last_wicket_title.webp',
  lastWicketPosterGameImg: '/images/game_posters/last_wicket_img.webp',
  penaltyKickPosterPosterBg: '/images/game_posters/penalty_kicks_bg.webp',
  penaltyKickPosterPosterTitle: '/images/game_posters/penalty_kicks_title.webp',
  penaltyKickPosterPosterGameImg: '/images/game_posters/penalty_kicks_img.webp',
  smallArcherPosterBg: '/images/game_posters/small_archer_bg.webp',
  smallArcherPosterTitle: '/images/game_posters/small_archer_title.webp',
  smallArcherPosterGameImg: '/images/game_posters/small_archer_img.webp',
  fruitDynastyPosterBg: '/images/game_posters/fruit_dynasty_chop_bg.webp',
  fruitDynastyPosterTitle: '/images/game_posters/fruit_dynasty_chop_title.webp',
  fruitDynastyPosterGameImg: '/images/game_posters/fruit_dynasty_chop_img.webp',
  carRacePosterBg: '/images/game_posters/car_race_bg.webp',
  carRacePosterTitle: '/images/game_posters/car_race_title.webp',
  carRacePosterGameImg: '/images/game_posters/car_race_img.webp',
  boxTowerPosterBg: '/images/game_posters/box_tower_bg.webp',
  boxTowerPosterTitle: '/images/game_posters/box_tower_title.webp',
  boxTowerPosterGameImg: '/images/game_posters/box_tower_img.webp',
  popUpPosterBg: '/images/game_posters/pop_up_bg.webp',
  popUpPosterTitle: '/images/game_posters/pop_up_title.webp',
  popUpPosterGameImg: '/images/game_posters/pop_up_img.webp',
  smashTheRockPosterBg: '/images/game_posters/smash_the_rock_bg.webp',
  smashTheRockPosterTitle: '/images/game_posters/smash_the_rock_title.webp',
  smashTheRockPosterGameImg: '/images/game_posters/smash_the_rock_img.webp',
  failureIndicator: '/images/failure_indicator.webp',
  successIndicator: '/images/success_indicator.webp',
  yesNoFantasyPosterBg: '/images/game_posters/yes_no_fantasy_bg.webp',
  yesNoFantasyPosterTitle: '/images/game_posters/yes_no_fantasy_title.webp',
  yesNoFantasyPosterGameImg: '/images/game_posters/yes_no_fantasy_image.webp',
  Ribbon: '/images/Ribbon.webp',
  HourGlass: '/images/Hour_glass.webp',
  backgroundImg: '/images/background_img.png',
  swords: '/images/swords.webp',
  MatchMakingAvatarFrame: '/images/match_making_avatar_frame.webp',
  MatchMakingVs: '/images/match_making_vs.webp',
  MatchMakingWinnerStrap: '/images/match_making_winner_strap.webp',
  MatchMakingLoserStrap: '/images/match_making_loser_strap.webp',
  avatarIcon: '/images/avatarIcon.png',
  ShareIcon: 'images/ShareIcon.webp',
  DashboardBanner: '/images/top_banner_web.webp',
  DashboardBannerMobile: '/images/top_banner_mWeb.webp',
  Live: 'images/Live.webp',
  OfferPercentage: '/images/Offer_Percentage.webp',
  NetflixWhiteBg: 'images/Netflix-white-bg.webp',
  Ribbon_Yellow: '/images/Ribbon_Yellow.webp',
  close: '/images/close.webp',
  profileTransactionsButtonBackground: '/images/button_background.webp',
  moneyHeader: '/images/money_header.webp',
  fantasyCricketBg: '/images/fantasy_cricket_bg.webp',
  pokerBg: '/images/poker-bg.webp',
  home: '/images/icons/home.webp',
  homeActive: '/images/icons/home_active.webp',
  arcade: '/images/icons/arcade.webp',
  arcadeActive: '/images/icons/arcade_active.webp',
  cards: '/images/icons/cards.webp',
  favourites: '/images/icons/favourites.webp',
  history: '/images/icons/history.webp',
  historyActive: '/images/icons/history_active.webp',
  logout: '/images/icons/logout.webp',
  new: '/images/icons/new.webp',
  puzzles: '/images/icons/puzzles.webp',
  puzzlesActive: '/images/icons/puzzles_active.webp',
  quiz: '/images/icons/quiz.webp',
  quizActive: '/images/icons/quiz_active.webp',
  racing: '/images/icons/racing.webp',
  racingActive: '/images/icons/racing_active.webp',
  sports: '/images/icons/sports.webp',
  sportsActive: '/images/icons/sports_active.webp',
  carRaceMinigamePortrait: '/images/minigames_posters/portrait/car_race.webp',
  carRaceMinigameLandscape: '/images/minigames_posters/landscape/car_race_landscape.webp',
  batterChallengeMinigamePortrait: '/images/minigames_posters/portrait/batter_challenge.webp',
  batterChallengeMinigameLandscape:
    '/images/minigames_posters/landscape/batter_challenge_landscape.webp',
  boxTowerMinigamePortrait: '/images/minigames_posters/portrait/box_tower.webp',
  boxTowerMinigameLandscape: '/images/minigames_posters/landscape/box_tower_landscape.webp',
  fruitDynastyMinigamePortrait: '/images/minigames_posters/portrait/fruit_dynasty.webp',
  fruitDynastyMinigameLandscape: '/images/minigames_posters/landscape/fruit_dynasty_landscape.webp',
  lastWicketMinigamePortrait: '/images/minigames_posters/portrait/last_wicket.webp',
  lastWicketMinigameLandscape: '/images/minigames_posters/landscape/last_wicket_landscape.webp',
  numberSnakeMinigamePortrait: '/images/minigames_posters/portrait/number_snake.webp',
  numberSnakeMinigameLandscape: '/images/minigames_posters/landscape/number_snake_landscape.webp',
  penaltyKicksMinigamePortrait: '/images/minigames_posters/portrait/penalty_kicks.webp',
  penaltyKicksMinigameLandscape: '/images/minigames_posters/landscape/penalty_kicks_landscape.webp',
  popUpMinigamePortrait: '/images/minigames_posters/portrait/popup.webp',
  popUpMinigameLandscape: '/images/minigames_posters/landscape/popup_landscape.webp',
  quickMathsMinigamePortrait: '/images/minigames_posters/portrait/quick_maths.webp',
  quickMathsMinigameLandscape: '/images/minigames_posters/landscape/quick_maths_landscape.webp',
  smallArcherMinigamePortrait: '/images/minigames_posters/portrait/small_archer.webp',
  smallArcherMinigameLandscape: '/images/minigames_posters/landscape/small_archer_landscape.webp',
  smashTheRockMinigamePortrait: '/images/minigames_posters/portrait/smash_the_rock.webp',
  smashTheRockMinigameLandscape:
    '/images/minigames_posters/landscape/smash_the_rock_landscape.webp',
  liveLandscape: '/images/live_landscape.webp',
  moneyLightGreen: '/images/money_light_green.webp',
  rank2: '/images/rank2.webp',
  rank3: '/images/rank3.webp',
  myAnswerTabBtnBg: '/images/myanswertab_btn_bg.webp',
  YesNo_2xBtnSelect: '/images/yes_no_2x_btn_select.webp',
  YesNo_2xBtn: '/images/yes_no_2x_btn.webp',
  questionCorrectTick: '/images/question_correct_tick.webp',
  questionWrongClose: '/images/question _wrong_close.webp',
  bulb: '/images/bulb.webp',
  yesNoInfo: '/images/yesnoinfo.webp',
  spinTheWheel: '/images/spin_the_wheel_web.webp',
  dailyRewards: '/images/daily_rewards_web.webp',
  spinTheWheelMob: '/images/spin_the_wheel_mWeb.webp',
  dailyRewardsMob: '/images/daily_rewards_mWeb.webp',
  playerVsPlayer: '/images/player_vs_player.webp',
  chestActive: '/images/daily_rewards/chests/chest_active.webp',
  chestClosed: '/images/daily_rewards/chests/chest_closed.webp',
  lock: '/images/daily_rewards/lock.webp',
  iGamio: '/images/iGamio.webp',
  leaderBoardGameBg: '/images/game_posters/leaderboard_games_bg.webp',
  leaderBoardGameTitle: '/images/game_posters/leaderboard_games_title.webp',
  leaderBoardGameimg: '/images/game_posters/leaderboard_games_img.webp',
  pvpGameBg: '/images/game_posters/pvp_games_bg.webp',
  pvpGameTitle: '/images/game_posters/pvp_games_title.webp',
  pvpGameimg: '/images/game_posters/pvp_games_img.webp',
  warning: '/images/warning.webp',
  fruitDynastyPvpPosterBg: '/images/game_posters/fruit_dynasty_pvp_chop_bg.webp',
  fruitDynastyPvpPosterTitle: '/images/game_posters/fruit_dynasty_pvp_chop_title.webp',
  fruitDynastyPvpPosterGameImg: '/images/game_posters/fruit_dynasty_pvp_chop_img.webp',
  firstPrize: '/images/first_prize.webp',
  backgroundImgDark: '/images/background_img_dark.png',
  shareContestIconDark: '/images/share_contest_icon_dark.webp',
  YesNo_2xBtnSelect_dark: '/images/yes_no_2x_btn_select_dark.webp',
  YesNo_2xBtn_dark: '/images/yes_no_2x_btn_dark.webp',
  closeDark: '/images/close_dark.webp',
  loginSignUpBanner: '/images/login__signUp__banner.webp',
  instagram: '/images/instagram.webp',
  twitter: '/images/twitter.webp',
  linkedin: '/images/linkedin.webp',
  youtube: '/images/youtube.webp',
  facebook: '/images/facebook.webp',
  addCashPlus: '/images/add_cash_plus.webp',
  coin: '/images/coin.webp',
  xp: '/images/xp.webp',
  leaderboard: '/images/leaderboard_games.webp',
  playerVsPlayerGames: '/images/player_vs_player.webp',
  fantasyCricketIcon: '/images/fantasy_cricket_icon.webp',
  highestScoreBorder: '/images/highest_score_border.webp',
  currentScoreBorder: '/images/current_score_border.webp',
  hundredPercentBonusContestIcon: '/images/contest_icons/100_bonus.webp',
  giveawayContestIcon: '/images/contest_icons/giveaway.webp',
  headToHeadContestIcon: '/images/contest_icons/head_to_head.webp',
  lowestCommissionContestIcon: '/images/contest_icons/lowest_commission.webp',
  grandLeagueContestIcon: '/images/contest_icons/grand_league.webp',
  highScoreRibbon: '/images/high_score_ribbon.webp',
  lastScoreRibbon: '/images/last_score_ribbon.webp',
  cidBikeRiderPosterBg: '/images/game_posters/cid_biker_rider_bg.webp',
  cidBikeRiderPosterTitle: '/images/game_posters/cid_biker_rider_title.webp',
  cidBikeRiderPosterGameImg: '/images/game_posters/cid_biker_rider_img.webp',
  cidBikeRiderMinigamePortrait: '/images/minigames_posters/portrait/cid_biker_rider_portrait.webp',
  cidBikeRiderMinigameLandscape:
    '/images/minigames_posters/landscape/cid_biker_rider_landscape.webp',
  honeyBunnyJumpPosterBg: '/images/game_posters/honey_bunny_jump_bg.webp',
  honeyBunnyJumpPosterTitle: '/images/game_posters/honey_bunny_jump_title.webp',
  honeyBunnyJumpPosterGameImg: '/images/game_posters/honey_bunny_jump_img.webp',
  honeyBunnyJumpMinigamePortrait:
    '/images/minigames_posters/portrait/honey_bunny_jump_portrait.webp',
  honeyBunnyJumpMinigameLandscape:
    '/images/minigames_posters/landscape/honey_bunny_jump_landscape.webp',
  honeyBunnyRiseUpPosterBg: '/images/game_posters/honey_bunny_rise_up_bg.webp',
  honeyBunnyRiseUpPosterTitle: '/images/game_posters/honey_bunny_rise_up_title.webp',
  honeyBunnyRiseUpPosterGameImg: '/images/game_posters/honey_bunny_rise_up_img.webp',
  honeyBunnyRiseUpMinigamePortrait:
    '/images/minigames_posters/portrait/honey_bunny_rise_up_portrait.webp',
  honeyBunnyRiseUpMinigameLandscape:
    '/images/minigames_posters/landscape/honey_bunny_rise_up_landscape.webp',
  goldMinerPosterBg: '/images/game_posters/gold_miner_bg.webp',
  goldMinerPosterTitle: '/images/game_posters/gold_miner_title.webp',
  goldMinerPosterGameImg: '/images/game_posters/gold_miner_img.webp',
  goldMinerMinigamePortrait: '/images/minigames_posters/portrait/gold_miner_portrait.webp',
  goldMinerMinigameLandscape: '/images/minigames_posters/landscape/gold_miner_landscape.webp',
  dayaAirShooterPosterBg: '/images/game_posters/daya_air_shooter_bg.webp',
  dayaAirShooterPosterTitle: '/images/game_posters/daya_air_shooter_title.webp',
  dayaAirShooterPosterGameImg: '/images/game_posters/daya_air_shooter_img.webp',
  dayaAirShooterMinigamePortrait:
    '/images/minigames_posters/portrait/daya_air_shooter_portrait.webp',
  dayaAirShooterMinigameLandscape:
    '/images/minigames_posters/landscape/daya_air_shooter_landscape.webp',
  classicBowlingPosterBg: '/images/game_posters/classic_bowling_bg.webp',
  classicBowlingPosterTitle: '/images/game_posters/classic_bowling_title.webp',
  classicBowlingPosterGameImg: '/images/game_posters/classic_bowling_img.webp',
  classicBowlingMinigamePortrait:
    '/images/minigames_posters/portrait/classic_bowling_portrait.webp',
  classicBowlingMinigameLandscape:
    '/images/minigames_posters/landscape/classic_bowling_landscape.webp',
  duckShooterPosterBg: '/images/game_posters/duck_shooter_bg.webp',
  duckShooterPosterTitle: '/images/game_posters/duck_shooter_title.webp',
  duckShooterPosterGameImg: '/images/game_posters/duck_shooter_img.webp',
  duckShooterMinigamePortrait: '/images/minigames_posters/portrait/duck_shooter_portrait.webp',
  duckShooterMinigameLandscape: '/images/minigames_posters/landscape/duck_shooter_landscape.webp',
  brickBreakerPosterBg: '/images/game_posters/brick_breaker_bg.webp',
  brickBreakerPosterTitle: '/images/game_posters/brick_breaker_title.webp',
  brickBreakerPosterGameImg: '/images/game_posters/brick_breaker_img.webp',
  brickBreakerMinigamePortrait: '/images/minigames_posters/portrait/brick_breaker_portrait.webp',
  brickBreakerMinigameLandscape: '/images/minigames_posters/landscape/brick_breaker_landscape.webp',
  colorBricksPosterBg: '/images/game_posters/color_bricks_bg.webp',
  colorBricksPosterTitle: '/images/game_posters/color_bricks_title.webp',
  colorBricksPosterGameImg: '/images/game_posters/color_bricks_img.webp',
  colorBricksMinigamePortrait: '/images/minigames_posters/portrait/color_bricks_portrait.webp',
  colorBricksMinigameLandscape: '/images/minigames_posters/landscape/color_bricks_landscape.webp',
  cricketFielderChallengePosterBg: '/images/game_posters/cricket_fielder_challenge_bg.webp',
  cricketFielderChallengePosterTitle: '/images/game_posters/cricket_fielder_challenge_title.webp',
  cricketFielderChallengePosterGameImg: '/images/game_posters/cricket_fielder_challenge_img.webp',
  cricketFielderChallengeMinigamePortrait:
    '/images/minigames_posters/portrait/cricket_fielder_challenge_portrait.webp',
  cricketFielderChallengeMinigameLandscape:
    '/images/minigames_posters/landscape/cricket_fielder_challenge_landscape.webp',
  shootRobbersPosterBg: '/images/game_posters/shoot_robbers_bg.webp',
  shootRobbersPosterTitle: '/images/game_posters/shoot_robbers_title.webp',
  shootRobbersPosterGameImg: '/images/game_posters/shoot_robbers_img.webp',
  shootRobbersMinigamePortrait: '/images/minigames_posters/portrait/shoot_robbers_portrait.webp',
  shootRobbersMinigameLandscape: '/images/minigames_posters/landscape/shoot_robbers_landscape.webp',
  baseBallProPosterBg: '/images/game_posters/baseball_pro_bg.webp',
  baseBallProPosterTitle: '/images/game_posters/baseball_pro_title.webp',
  baseBallProPosterGameImg: '/images/game_posters/baseball_pro_img.webp',
  baseBallProMinigamePortrait: '/images/minigames_posters/portrait/baseball_pro_portrait.webp',
  baseBallProMinigameLandscape: '/images/minigames_posters/landscape/baseball_pro_landscape.webp',
  trafficCommandPosterBg: '/images/game_posters/the_traffic_command_bg.webp',
  trafficCommandPosterTitle: '/images/game_posters/the_traffic_command_title.webp',
  trafficCommandPosterGameImg: '/images/game_posters/the_traffic_command_img.webp',
  trafficCommandMinigamePortrait:
    '/images/minigames_posters/portrait/the_traffic_command_portrait.webp',
  trafficCommandMinigameLandscape:
    '/images/minigames_posters/landscape/the_traffic_command_landscape.webp',
  strategy: '/images/icons/strategy.webp',
  strategyActive: '/images/icons/strategy_active.webp',
  babesKitchenPosterBg: '/images/game_posters/babes_kitchen_bg.webp',
  babesKitchenPosterTitle: '/images/game_posters/babes_kitchen_title.webp',
  babesKitchenPosterGameImg: '/images/game_posters/babes_kitchen_img.webp',
  babesKitchenMinigamePortrait: '/images/minigames_posters/portrait/babes_kitchen_portrait.webp',
  babesKitchenMinigameLandscape: '/images/minigames_posters/landscape/babes_kitchen_landscape.webp',
  crazyTaxiPosterBg: '/images/game_posters/crazy_taxi_bg.webp',
  crazyTaxiPosterTitle: '/images/game_posters/crazy_taxi_title.webp',
  crazyTaxiPosterGameImg: '/images/game_posters/crazy_taxi_img.webp',
  crazyTaxiMinigamePortrait: '/images/minigames_posters/portrait/crazy_taxi_portrait.webp',
  crazyTaxiMinigameLandscape: '/images/minigames_posters/landscape/crazy_taxi_landscape.webp',
  ticTacToePosterBg: '/images/game_posters/tictactoe_bg.webp',
  ticTacToePosterTitle: '/images/game_posters/tictactoe_title.webp',
  ticTacToePosterGameImg: '/images/game_posters/tictactoe_img.webp',
  ticTacToeMinigamePortrait: '/images/minigames_posters/portrait/tic_tac_toe_portrait.webp',
  ticTacToeMinigameLandscape: '/images/minigames_posters/landscape/tic_tac_toe_landscape.webp',
  frogStaticPosterBg: '/images/game_posters/frogtastic_bg.webp',
  frogStaticPosterTitle: '/images/game_posters/frogtastic_title.webp',
  frogStaticPosterGameImg: '/images/game_posters/frogtastic_img.webp',
  frogStaticMinigamePortrait: '/images/minigames_posters/portrait/frogtastic_portrait.webp',
  frogStaticMinigameLandscape: '/images/minigames_posters/landscape/frogtastic_landscape.webp',
  quickMathsPvpPosterBg: '/images/game_posters/quick_math_h2h_bg.webp',
  quickMathsPvpPosterTitle: '/images/game_posters/quick_math_h2h_title.webp',
  quickMathsPvpPosterGameImg: '/images/game_posters/quick_math_h2h_img.webp',
  quickMathsPvpMinigamePortrait: '/images/minigames_posters/portrait/quick_math_portrait.webp',
  quickMathsPvpMinigameLandscape: '/images/minigames_posters/landscape/quick_math_landscape.webp',
  triviaQuizPosterBg: '/images/game_posters/bollywoodtrivia_bg.webp',
  triviaQuizPosterTitle: '/images/game_posters/bollywoodtrivia_title.webp',
  triviaQuizPosterGameImg: '/images/game_posters/bollywoodtrivia_img.webp',
  triviaQuizMinigamePortrait: '/images/minigames_posters/portrait/bollywood_trivia_portrait.webp',
  triviaQuizMinigameLandscape:
    '/images/minigames_posters/landscape/bollywood_trivia_landscape.webp',
  rescueRocketPosterBg: '/images/game_posters/the_rescue_rocket_bg.webp',
  rescueRocketPosterTitle: '/images/game_posters/the_rescue_rocket_title.webp',
  rescueRocketPosterGameImg: '/images/game_posters/the_rescue_rocket_img.webp',
  rescueRocketMinigamePortrait:
    '/images/minigames_posters/portrait/the_rescue_rocket_portrait.webp',
  rescueRocketMinigameLandscape:
    '/images/minigames_posters/landscape/the_rescue_rocket_landscape.webp',
  highestScoreBorderMobile: '/images/highest_score_border_mweb.webp',
  currentScoreBorderMobile: '/images/current_score_border_mweb.webp',
  ludoBg: '/images/game_posters/ludo_bg.webp',
  ludoTitle: '/images/game_posters/ludo_title.webp',
  ludoImg: '/images/game_posters/ludo_img.webp',
  ludoPortrait: '/images/minigames_posters/portrait/ludo.png',
  ludoLandscape: '/images/minigames_posters/landscape/ludo.png'
};
